import type { BulkInviteStatus } from '@qse/api'
import { Mail } from 'lucide-react'

interface EmailsNotSentNoteProps {
  count: number
  status?: BulkInviteStatus
}

/**
 * Info note for invitations that were created but whose email is still pending.
 * Renders nothing when there's nothing to report, or when the request FAILED
 * (no invitations were created, so there is no one to re-notify).
 */
export default function BulkInviteEmailsNotSentNote({ count, status }: EmailsNotSentNoteProps) {
  if (count <= 0 || status === 'FAILED') return null

  return (
    <div className="flex items-start gap-3 rounded-lg border border-blue-500/30 bg-blue-500/10 p-3">
      <Mail className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" />
      <p className="text-sm text-blue-900 dark:text-blue-100">
        {count.toLocaleString()} invite{count === 1 ? '' : 's'} created, but their email delivery is
        still pending. These users can be re-notified.
      </p>
    </div>
  )
}
